import { createStorageHook } from './storage';

export interface WithSessionStorage {
  sessionStorage: {
    value: any;
    setValue: Function;
  };
}

const {
  Storage: SessionStorage,
  StorageContext: SessionStorageContext,
  useStorage: useSessionStorage,
  withStorage: withSessionStorage,
} = createStorageHook('sessionStorage');

export { SessionStorage, SessionStorageContext, useSessionStorage, withSessionStorage };

export default SessionStorage;
